<label [hidden]="!showLabel"
  [id]="radioGroupLabelId">
  {{ label }}
</label>

<mat-radio-group [class.vertical]="direction === 'vertical'"
  [formControl]="formControlRef"
  [required]="required"
  [attr.aria-labelledby]="radioGroupLabelId">
  <mat-radio-button *ngFor="let option of options"
    [color]="color"
    [value]="option.value"
    [class.large]="size === 'large'">
    {{ option.label }}
  </mat-radio-button>
</mat-radio-group>
